/* DM • Options natives v1 (13/10/2026). Lit un set d'options (JSON généré depuis Globo), affiche les champs,
   applique les conditions, calcule le total et ajoute au panier dans la même forme que Globo. */
(function () {
  'use strict';
  var S = window.dmrOptionsStrings || {};
  var TYPES_INPUT = { text: 1, textarea: 1, select: 1, dropdown: 1, switch: 1, 'image-swatches': 1, 'color-swatches': 1, buttons: 1, file: 1, checkbox: 1, radio: 1, number: 1 };

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace('.', ',');
    var f = format || '€{{amount_with_comma_separator}}';
    f = f.replace(/<[^>]+>/g, '');
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function L(obj, base, loc) {
    if (!obj) return '';
    var v = obj[base + '_' + loc];
    if (v == null || v === '') v = obj[base + '_' + loc.split('-')[0]];
    if (v == null || v === '') v = obj[base];
    return v == null ? '' : String(v).replace(/\s+[\u2014\u2013]\s+/g, ', ');
  }
  var realPricesRef = {}, realComparesRef = {};
  function discountOf(v) {
    if (!v || !v.variant_id || !priceOf(v)) return 0;
    return /holo|chrom/i.test(String(v.value || '')) ? 20 : 0;
  }
  function popularOf(txt) {
    var m = /\(([^)]*)\)/.exec(txt || '');
    return m && /populaire|popular|beliebt|popolare/i.test(m[1]) ? m[1].replace(/[^\p{L}\s]/gu, '').trim() : '';
  }
  function isOfferField(el, byId) {
    var w = el && el.clo && el.clo.whens || [];
    return el.clo && el.clo.display !== 'hide' && w.some(function (x) { return /holo|chrom/i.test(String(x.value || '')); });
  }
  function priceOf(v) {
    if (!v || !v.variant_id) return 0;
    if (realPricesRef[String(v.variant_id)] != null) return realPricesRef[String(v.variant_id)];
    return v.variant_price ? Math.round(parseFloat(v.variant_price) * 100) : 0;
  }
  function imgUrl(root, name) {
    if (!name) return '';
    if (/^https?:/.test(name)) return name;
    return root + name + (/\.[a-z0-9]{3,4}$/i.test(name) ? '' : '.jpg') + '?width=160';
  }

  function init(rootEl) {
    var d = rootEl.dataset;
    var loc = d.locale || 'fr';
    var formEl = rootEl.querySelector('[data-dmr-form]');
    var buyEl = rootEl.querySelector('[data-dmr-buy]');
    var totalEl = rootEl.querySelector('[data-dmr-total]');
    var btn = rootEl.querySelector('[data-dmr-submit]');
    var errEl = rootEl.querySelector('[data-dmr-error]');
    var filesRoot = d.filesRoot || '/cdn/shop/files/';
    var variants = {}, compares = {};
    (d.variants || '').split(',').forEach(function (p) { var kv = p.split(':'); if (kv[0]) variants[kv[0]] = parseInt(kv[1], 10) || 0; });
    (d.compares || '').split(',').forEach(function (p) { var kv = p.split(':'); if (kv[0]) compares[kv[0]] = parseInt(kv[1], 10) || 0; });
    var compareEl = rootEl.querySelector('[data-dmr-compare]');
    var qtyInput = rootEl.querySelector('[data-dmr-qty-input]');
    var editGroup = d.editGroup || new URL(window.location.href).searchParams.get('dmr_edit');
    var editLine = null, keptFiles = {};
    function qty() { if (editLine) return editLine.quantity; var q = parseInt(qtyInput && qtyInput.value, 10); return q > 0 ? Math.min(q, 20) : 1; }
    rootEl.querySelectorAll('[data-dmr-qty]').forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = Math.max(1, Math.min(20, qty() + (b.dataset.dmrQty === '+' ? 1 : -1))); onChange(); }); });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); onChange(); });
    var btnLabel = rootEl.querySelector('[data-dmr-button-label]') || btn;
    var elements = [];
    var byId = {};
    var state = {};
    var realPrices = {}, realCompares = {};
    if (d.hideGlobo === 'true') document.documentElement.classList.add('dmr-options-active');
    function loadRealPrices(set) {
      var handles = {};
      (set.elements || []).forEach(function (el) {
        if (el.addon_product && el.addon_product.product_handle) handles[el.addon_product.product_handle] = 1;
        (el.option_values || []).forEach(function (v) { if (v.product_handle) handles[v.product_handle] = 1; });
      });
      return Promise.all(Object.keys(handles).map(function (h) {
        return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (p && p.variants) p.variants.forEach(function (v) { realPrices[String(v.id)] = v.price; if (v.compare_at_price && v.compare_at_price > v.price) realCompares[String(v.id)] = v.compare_at_price; });
        }).catch(function () {});
      }));
    }

    function currentVariantId() {
      if (d.dmrInline && d.variantId) return String(d.variantId);
      var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (f && f.value) return String(f.value);
      var u = new URL(window.location.href).searchParams.get('variant');
      return u || d.variantId;
    }
    function basePrice() { var id = currentVariantId(); return variants[id] != null ? variants[id] : parseInt(d.variantPrice, 10) || 0; }

    function valueText(el, v) { return L(v, 'value', loc) || v.value || ''; }

    function render() {
      var html = '';
      var openGroup = false, currentGroup = '';
      // numéro de pilote : case courte, numéros chromés / holo juste à côté
      var numEl = elements.filter(function (e) { return (e.type === 'text' || e.type === 'number') && /^num[ée]ro (de|du) pilote/i.test((e.label || '').trim()); })[0];
      var swEl = elements.filter(function (e) { return e.type === 'image-swatches' && (e.option_values || []).some(function (v) { return /holo/i.test(v.value || '') && /num/i.test(v.value || ''); }); })[0];
      var pairNum = !!(numEl && swEl), numHtml = '', swHtml = '', numLabel = '';
      // modèle et année de la moto : sur une seule ligne
      var modelEl = null, yearEl = null;
      elements.forEach(function (e, i) { var n = elements[i + 1]; if (!modelEl && n && (e.type === 'text' || e.type === 'number') && (n.type === 'text' || n.type === 'number') && /^mod[eè]le de votre moto/i.test((e.label || '').trim()) && /^ann[ée]e de votre moto/i.test((n.label || '').trim())) { modelEl = e; yearEl = n; } });
      var pairHide = !!(modelEl && (modelEl.hidden_label || yearEl.hidden_label));
      elements.forEach(function (el, idx) {
        var id = esc(el.id);
        var label = L(el, 'label', loc);
        var inPair = pairNum && (el === numEl || el === swEl);
        if (inPair) { if (el === numEl) numLabel = esc(label) + (el.required ? '<span class="is-req">*</span>' : ''); label = ''; }
        var next = elements[idx + 1];
        if (el.type === 'group') { currentGroup = (L(el, 'label', loc) || '').trim().toLowerCase(); if (next && next.type === 'heading') label = ''; }
        if (el.type !== 'group' && label && label.trim().toLowerCase() === currentGroup) label = '';
        if (el.hidden_label && el.type !== 'switch' && el.type !== 'checkbox') label = '';
        var phOver = '';
        if (pairHide && (el === modelEl || el === yearEl)) { var phm = /^([^,:]+),\s*(.+)$/.exec(L(el, 'placeholder', loc)); label = phm ? phm[1] : ''; phOver = phm ? phm[2] : ''; }
        var help = L(el, 'helptext', loc);
        var req = el.required ? '<span class="is-req">*</span>' : '';
        if (el.type === 'group') {
          if (openGroup) html += '</div>';
          html += '<div class="dmr-options__group" data-dmr-el="' + id + '">' + (label ? '<h3 class="dmr-options__group-title">' + esc(label) + '</h3>' : '');
          openGroup = true; return;
        }
        var inner = '';
        var cls = 'dmr-options__field';
        if (el.type === 'heading') { var prev = elements[idx - 1]; var hcls = prev && prev.type === 'group' ? 'dmr-options__group-title' : 'dmr-options__group-title is-split'; html += '<h4 class="' + hcls + '" data-dmr-el="' + id + '">' + esc(L(el, 'text', loc)) + '</h4>'; return; }
        if (el.type === 'divider') { html += '<hr class="dmr-options__divider" data-dmr-el="' + id + '">'; return; }
        if (el.type === 'paragraph') { html += '<div class="dmr-options__para" data-dmr-el="' + id + '">' + L(el, 'text', loc).replace(/\s*style="[^"]*"/g, '') + '</div>'; return; }
        if (el.type === 'html') {
          var raw = L(el, 'text', loc);
          var tt = /__title">([\s\S]*?)<\/p>/.exec(raw), sub = /__sub">([\s\S]*?)<\/p>/.exec(raw), badge = /__badge">([\s\S]*?)<\/span>/.exec(raw), icon = /__icon">([\s\S]*?)<\/span>/.exec(raw);
          var clean = function (x) { return (x || '').replace(/\s*style="[^"]*"/g, '').replace(/\s*[\u2014\u2013]\s*/g, ', ').trim(); };
          if (tt) {
            html += '<div class="dmr-options__perk" data-dmr-el="' + id + '">' + (icon ? '<span class="dmr-options__perk-icon">' + clean(icon[1]) + '</span>' : '') + '<span class="dmr-options__perk-body"><strong>' + clean(tt[1]) + '</strong>' + (sub ? '<small>' + clean(sub[1]) + '</small>' : '') + '</span>' + (badge ? '<em>' + clean(badge[1]) + '</em>' : '') + '</div>';
          } else {
            html += '<div class="dmr-options__html" data-dmr-el="' + id + '">' + raw + '</div>';
          }
          return;
        }
        if (inPair && el === numEl) {
          var nph = L(el, 'placeholder', loc);
          inner = '<input type="text" name="' + id + '" placeholder="' + esc(nph) + '" autocomplete="off" maxlength="6" class="dmr-options__num">';
        } else if (el.type === 'text' || el.type === 'number') {
          inner = '<input type="text" name="' + id + '" placeholder="' + esc(phOver || L(el, 'placeholder', loc)) + '" autocomplete="off">';
        } else if (el.type === 'textarea') {
          inner = '<textarea name="' + id + '" placeholder="' + esc(L(el, 'placeholder', loc)) + '"></textarea>';
        } else if (el.type === 'select' || el.type === 'dropdown') {
          var ph = L(el, 'placeholder', loc) || S.pick || 'Choisir';
          inner = '<div class="dmr-options__select"><select name="' + id + '"><option value="">' + esc(ph) + '</option>';
          (el.option_values || []).forEach(function (v) {
            if (!v.value || v.value === 'option_1') return;
            var p = priceOf(v);
            inner += '<option value="' + esc(v.value) + '">' + esc(valueText(el, v)) + (p ? ' (+ ' + money(p, d.moneyFormat) + ')' : '') + '</option>';
          });
          inner += '</select></div>';
        } else if (el.type === 'switch' || el.type === 'checkbox') {
          var p0 = priceOf(el.addon_product);
          cls += ' dmr-options__field--switch';
          inner = '<label class="dmr-options__switch"><span class="dmr-options__switch-text">' + esc(label) + req + (p0 ? '<small>+ ' + money(p0, d.moneyFormat) + '</small>' : '') + '</span><input type="checkbox" name="' + id + '" value="' + esc(L(el, 'switch_label', loc) || S.yes || 'Oui') + '"><span class="dmr-options__toggle"></span></label>';
          label = '';
        } else if (el.type === 'image-swatches') {
          var multi = !!el.allow_multiple;
          inner = '<div class="dmr-options__cards">';
          (el.option_values || []).forEach(function (v, i) {
            var p = priceOf(v); var src = imgUrl(filesRoot, v.asset_name);
            var isMat = /mati[eè]re|material|impression/i.test((el.label_on_cart || '') + ' ' + (el.label || ''));
            var off = isMat ? discountOf(v) : 0; var txt = valueText(el, v); var pop = popularOf(txt);
            if (pop) txt = txt.replace(/\s*\([^)]*\)\s*/, ' ').trim();
            if (inPair) { txt = txt.replace(/^(num[ée]ros?|numbers?|nummern|n[úu]meros?|numeri)\s+(de\s+|com\s+)?/i, '').replace(/\s+(numbers?|nummern)$/i, '').trim(); txt = txt.charAt(0).toUpperCase() + txt.slice(1); }
            var offer = !p && isOfferField(el, byId);
            inner += '<label class="dmr-options__card' + (pop ? ' is-popular' : '') + '"><input type="' + (multi ? 'checkbox' : 'radio') + '" name="' + id + '" value="' + esc(v.value) + '"><span class="dmr-options__card-img">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" decoding="async" fetchpriority="low">' : '<span class="dmr-options__card-blank"></span>') + (p ? '<span class="dmr-options__card-price">+ ' + money(p, d.moneyFormat) + '</span>' : (offer ? '<span class="dmr-options__card-price is-free">' + esc(S.free || 'Offert') + '</span>' : '')) + (off ? '<span class="dmr-options__card-off">-' + off + '%</span>' : '') + (pop ? '<span class="dmr-options__card-pop">' + esc(pop) + '</span>' : '') + '<span class="dmr-options__card-check" aria-hidden="true"></span></span><span class="dmr-options__card-text">' + esc(txt) + '</span></label>';
          });
          inner += '</div>';
        } else if ((el.type === 'buttons' || el.type === 'radio') && /paisseur|thickness|dicke|grosor|spessore|espessura/i.test((el.label_on_cart || '') + ' ' + (el.label || ''))) {
          var single = (el.option_values || []).length === 1;
          inner = '<div class="dmr-options__thicks' + (single ? ' is-single' : '') + '">';
          (el.option_values || []).forEach(function (v) {
            var p = priceOf(v); var txt = valueText(el, v);
            var microns = (txt.match(/(\d{3})\s*(microns?|mikrom|micras|micron)/i) || [])[1] || (String(v.value).match(/(\d{3})/) || [])[1] || '';
            var name = txt.replace(/\(?\d{3}\s*(microns?|mikrometer|mikron|micras|micron)\)?/i, '').replace(/pose\s+facile|einfache anwendung|easy application|aplicaci[oó]n f[aá]cil|facile applicazione|aplica[cç][aã]o f[aá]cil/i, '').replace(/[()]/g, '').replace(/\s+/g, ' ').trim();
            var reco = !single && /550|premium/i.test(String(v.value));
            inner += '<label class="dmr-options__thick' + (reco ? ' is-reco' : '') + '"><input type="radio" name="' + id + '" value="' + esc(v.value) + '">' + (reco ? '<span class="dmr-options__thick-badge">' + esc(S.recommended || 'Conseillé') + '</span>' : '') + '<span class="dmr-options__thick-head"><strong>' + esc(name) + '</strong><em>' + (p ? '+ ' + money(p, d.moneyFormat) : esc(S.included || 'Inclus')) + '</em></span>' + (microns ? '<span class="dmr-options__thick-microns">' + esc(microns) + ' microns</span>' : '') + '<span class="dmr-options__thick-note">' + esc(/550|premium/i.test(String(v.value)) ? (S.thickPremium || '') : (S.thickStandard || '')) + '</span></label>';
          });
          inner += '</div>';
          var tnote = L(el, 'helptext', loc);
          if (tnote) inner += '<p class="dmr-options__thick-info">' + esc(tnote) + '</p>';
        } else if (el.type === 'buttons' || el.type === 'radio') {
          inner = '<div class="dmr-options__chips">';
          (el.option_values || []).forEach(function (v) {
            var p = priceOf(v); var reco = /550/.test(v.value || '');
            inner += '<label class="dmr-options__chip' + (reco ? ' is-recommended' : '') + '"><input type="radio" name="' + id + '" value="' + esc(v.value) + '">' + esc(valueText(el, v)) + (p ? '<small>+ ' + money(p, d.moneyFormat) + '</small>' : '') + (reco ? '<span class="dmr-options__badge">' + esc(S.recommended || 'Conseillé') + '</span>' : '') + '</label>';
          });
          inner += '</div>';
        } else if (el.type === 'color-swatches') {
          var multiC = !!el.allow_multiple;
          inner = '<div class="dmr-options__colors">';
          (el.option_values || []).forEach(function (v) {
            var p = priceOf(v); var c1 = v.color1 || '#ccc', c2 = v.color2;
            var bg = c2 ? 'linear-gradient(135deg,' + esc(c1) + ' 50%,' + esc(c2) + ' 50%)' : esc(c1);
            inner += '<label class="dmr-options__color" title="' + esc(valueText(el, v)) + '"><input type="' + (multiC ? 'checkbox' : 'radio') + '" name="' + id + '" value="' + esc(v.value) + '"><span class="dmr-options__color-dot" style="background:' + bg + '"></span><span class="dmr-options__color-text">' + esc(valueText(el, v)) + (p ? ' <small>+ ' + money(p, d.moneyFormat) + '</small>' : '') + '</span></label>';
          });
          inner += '</div>';
        } else if (el.type === 'file') {
          var acc = (el.allowed_extensions || []).map(function (e) { return '.' + e; }).join(',');
          cls += ' dmr-options__file';
          inner = '<label class="dmr-options__drop"><input type="file" name="' + id + '"' + (el.allow_multiple ? ' multiple' : '') + (acc ? ' accept="' + esc(acc) + '"' : '') + '><span class="dmr-options__drop-btn">' + esc(S.addFiles || 'Ajouter des fichiers') + '</span><span class="dmr-options__drop-names" data-dmr-names>' + esc(S.noFile || '') + '</span></label>';
        } else { return; }
        var fieldHtml = '<div class="' + cls + '" data-dmr-el="' + id + '" data-type="' + esc(el.type) + '">' + (label && !el.hidden_label_force ? '<div class="dmr-options__label"><span>' + esc(label) + req + '</span></div>' : '') + inner + (help && el.type !== 'buttons' ? '<p class="dmr-options__help">' + esc(help) + '</p>' : '') + '<p class="dmr-options__msg">' + esc(S.required || 'Ce choix est obligatoire.') + '</p></div>';
        if (inPair && el === numEl) { numHtml = fieldHtml; html += '%%DMR_NUM%%'; }
        else if (inPair) swHtml = fieldHtml;
        else if (el === modelEl) html += '<div class="dmr-options__pair">' + fieldHtml;
        else if (el === yearEl) html += fieldHtml + '</div>';
        else html += fieldHtml;
      });
      if (openGroup) html += '</div>';
      if (pairNum) html = html.replace('%%DMR_NUM%%', '<div class="dmr-options__numrow"><div class="dmr-options__label"><span>' + esc(numLabel).replace('&lt;span class=&quot;is-req&quot;&gt;*&lt;/span&gt;', '<span class="is-req">*</span>') + '</span></div><div class="dmr-options__numrow-in">' + numHtml + swHtml + '</div></div>');
      formEl.innerHTML = html;
      formEl.hidden = false; buyEl.hidden = false;
      rootEl.querySelector('.dmr-options__loading').hidden = true;
      // valeurs par défaut
      elements.forEach(function (el) {
        if (!el.default_value) return;
        var defs = Array.isArray(el.default_value) ? el.default_value : [el.default_value];
        defs.forEach(function (dv) {
          var box = formEl.querySelector('[data-dmr-el="' + el.id + '"]');
          if (!box) return;
          var cands = Array.prototype.slice.call(box.querySelectorAll('input[value], option[value]'));
          var want = String(dv).trim();
          var inp = cands.filter(function (c) { return c.value.trim() === want; })[0] || cands.filter(function (c) { return c.value.trim().indexOf(want) === 0; })[0];
          if (inp) { if (inp.tagName === 'OPTION') inp.selected = true; else inp.checked = true; }
        });
      });
      formEl.addEventListener('change', onChange);
      formEl.addEventListener('input', onChange);
      // 16/10/2026 : un choix facultatif (ex. numéros chromés / holographiques) se décoche en recliquant dessus.
      // Un bouton radio ne se décoche jamais tout seul : on note s'il était coché juste avant le clic.
      var optional = {};
      elements.forEach(function (el) { if (!el.required) optional[el.id] = 1; });
      var remember = function (e) {
        if (e.type === 'keydown' && e.key !== ' ' && e.key !== 'Enter') return;
        var lab = e.target.closest ? e.target.closest('label') : null;
        var inp = lab ? lab.querySelector('input[type=radio]') : (e.target.type === 'radio' ? e.target : null);
        if (inp) inp.dataset.dmrWas = inp.checked ? '1' : '';
      };
      formEl.addEventListener('pointerdown', remember, true);
      formEl.addEventListener('keydown', remember, true);
      formEl.addEventListener('click', function (e) {
        var inp = e.target;
        if (!inp || inp.type !== 'radio') return;
        var was = inp.dataset.dmrWas === '1'; inp.dataset.dmrWas = '';
        if (!was) return;
        var box = inp.closest('[data-dmr-el]');
        if (!box || !optional[box.getAttribute('data-dmr-el')]) return;
        inp.checked = false;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
      onChange();
    }

    function readState() {
      state = {};
      elements.forEach(function (el) {
        if (!TYPES_INPUT[el.type]) return;
        var box = formEl.querySelector('[data-dmr-el="' + el.id + '"]');
        if (!box) return;
        if (el.type === 'file') { var fi = box.querySelector('input[type=file]'); state[el.id] = fi && fi.files.length ? Array.prototype.slice.call(fi.files) : []; return; }
        if (el.type === 'switch' || el.type === 'checkbox') { var c = box.querySelector('input'); state[el.id] = c && c.checked ? c.value : ''; return; }
        if ((el.type === 'image-swatches' || el.type === 'color-swatches') && el.allow_multiple) { state[el.id] = Array.prototype.map.call(box.querySelectorAll('input:checked'), function (i) { return i.value; }); return; }
        var sel = box.querySelector('input:checked, select, input[type=text], textarea');
        if (sel && sel.tagName === 'SELECT') state[el.id] = sel.value;
        else if (sel && (sel.type === 'radio')) state[el.id] = sel.value;
        else if (sel) state[el.id] = sel.value.trim();
        else state[el.id] = '';
      });
    }
    function has(id) { var v = state[id]; if (keptFiles[id] && keptFiles[id].length && !(v && v.length)) return true; return Array.isArray(v) ? v.length > 0 : !!v; }
    function visible(el) {
      if (!el.clo || !el.clo.whens || !el.clo.whens.length) return true;
      var res = el.clo.whens.map(function (w) {
        if (!w.select || w.select === 'null') return true;
        var target = byId[w.select];
        if (target && !visible(target)) return false;
        var v = state[w.select]; var arr = Array.isArray(v) ? v : (v ? [v] : []);
        var val = (w.value || '').trim();
        var norm = arr.map(function (x) { return String(x).trim(); });
        switch (w.where) {
          case 'ENABLED': case 'NOT_EMPTY': case 'IS_NOT_EMPTY': return arr.length > 0 && arr[0] !== '';
          case 'DISABLED': case 'EMPTY': case 'IS_EMPTY': return !(arr.length > 0 && arr[0] !== '');
          case 'EQUALS': return norm.indexOf(val) !== -1;
          case 'NOT_EQUALS': return norm.indexOf(val) === -1;
          case 'CONTAINS': return norm.some(function (x) { return x.indexOf(val) !== -1; });
          case 'NOT_CONTAINS': return !norm.some(function (x) { return x.indexOf(val) !== -1; });
          default: return true;
        }
      });
      var ok = el.clo.match === 'any' ? res.some(Boolean) : res.every(Boolean);
      return el.clo.display === 'hide' ? !ok : ok;
    }
    function addons() {
      var out = [];
      elements.forEach(function (el) {
        if (!TYPES_INPUT[el.type] || !visible(el)) return;
        var v = state[el.id]; var arr = Array.isArray(v) ? v : (v ? [v] : []);
        var cartLabel = el.label_on_cart || L(el, 'label', loc);
        if ((el.type === 'switch' || el.type === 'checkbox') && arr.length && el.addon_product && el.addon_product.variant_id) {
          out.push({ variant: el.addon_product.variant_id, price: priceOf(el.addon_product), field: cartLabel });
        }
        if (el.type === 'textarea' && arr.length && el.addon_product && el.addon_product.variant_id) {
          out.push({ variant: el.addon_product.variant_id, price: priceOf(el.addon_product), field: cartLabel });
        }
        (el.option_values || []).forEach(function (ov) {
          if (arr.indexOf(ov.value) !== -1 && ov.variant_id) out.push({ variant: ov.variant_id, price: priceOf(ov), field: cartLabel });
        });
      });
      return out;
    }
    function onChange() {
      readState();
      elements.forEach(function (el) {
        var box = formEl.querySelector('[data-dmr-el="' + el.id + '"]');
        if (!box) return;
        var vis = visible(el);
        box.classList.toggle('is-hidden', !vis);
        box.classList.remove('is-invalid');
        var fi = box.querySelector('input[type=file]');
        if (fi) { var names = box.querySelector('[data-dmr-names]'); var list = Array.prototype.map.call(fi.files, function (f) { return f.name; }); var kept = keptFiles[el.id] || []; names.textContent = list.length ? list.join(', ') : (kept.length ? (S.keptFiles || 'Fichiers déjà envoyés : ') + kept.length : (S.noFile || '')); box.classList.toggle('has-files', list.length > 0 || kept.length > 0); }
        box.querySelectorAll('.dmr-options__chip, .dmr-options__card, .dmr-options__thick, .dmr-options__color').forEach(function (lab) { var i = lab.querySelector('input'); lab.classList.toggle('is-on', !!(i && i.checked)); });
      });
      // ligne de séparation : sous les champs ouverts par un interrupteur, pas entre l'interrupteur et ses champs
      formEl.querySelectorAll('.is-open, .is-sub-end').forEach(function (n) { n.classList.remove('is-open', 'is-sub-end'); });
      var shown = function (n) { if (n.classList.contains('dmr-options__numrow') || n.classList.contains('dmr-options__pair')) return !!n.querySelector('.dmr-options__field:not(.is-hidden)'); return n.classList.contains('dmr-options__field') && !n.classList.contains('is-hidden'); };
      formEl.querySelectorAll('.dmr-options__field--switch').forEach(function (sw) {
        var c = sw.querySelector('input'); if (sw.classList.contains('is-hidden') || !c || !c.checked) return;
        var last = null, n = sw.nextElementSibling;
        while (n && !n.classList.contains('dmr-options__field--switch') && (n.classList.contains('dmr-options__field') || n.classList.contains('dmr-options__numrow') || n.classList.contains('dmr-options__pair'))) { if (shown(n)) last = n; n = n.nextElementSibling; }
        if (last) { sw.classList.add('is-open'); last.classList.add('is-sub-end'); }
      });
      var extraSum = addons().reduce(function (s, a) { return s + a.price; }, 0);
      var total = (basePrice() + extraSum) * qty();
      totalEl.textContent = money(total, d.moneyFormat);
      var cmp = compares[currentVariantId()] || 0;
      if (compareEl) { if (cmp > basePrice()) { compareEl.textContent = money((cmp + extraSum) * qty(), d.moneyFormat); compareEl.hidden = false; } else { compareEl.hidden = true; } }
    }
    function validate() {
      var ok = true; var first = null;
      elements.forEach(function (el) {
        if (!el.required || !TYPES_INPUT[el.type] || !visible(el)) return;
        if (!has(el.id)) { ok = false; var box = formEl.querySelector('[data-dmr-el="' + el.id + '"]'); if (box) { box.classList.add('is-invalid'); if (!first) first = box; } }
      });
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return ok;
    }
    function submit() {
      errEl.hidden = true;
      if (!validate()) { errEl.textContent = S.required || ''; errEl.hidden = false; return; }
      var group = String(Date.now());
      var fd = new FormData();
      fd.append('id', currentVariantId());
      fd.append('quantity', String(qty()));
      fd.append('properties[_has_gpo]', d.setId);
      elements.forEach(function (el) {
        if (!TYPES_INPUT[el.type] || !visible(el)) return;
        var v = state[el.id];
        var key = el.label_on_cart || L(el, 'label', loc);
        if (el.type === 'file') {
          if ((!v || !v.length) && keptFiles[el.id]) { keptFiles[el.id].forEach(function (kv) { fd.append('properties[' + kv[0] + ']', kv[1]); }); return; }
          (v || []).forEach(function (f, i) { fd.append('properties[' + key + (v.length > 1 ? ' ' + (i + 1) : '') + ']', f, f.name); }); return;
        }
        if (Array.isArray(v)) { if (v.length) fd.append('properties[' + key + ']', v.map(function (x) { return textOf(el, x); }).join(', ')); return; }
        if (v) fd.append('properties[' + key + ']', textOf(el, v));
      });
      fd.append('properties[_gpo_product_group]', group);
      var extra = addons();
      btn.disabled = true; var oldLabel = btnLabel.textContent; btnLabel.textContent = S.adding || oldLabel;
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-DMR-Sync': '1' } })
        .then(function (r) { if (!r.ok) throw new Error('main'); return r.json(); })
        .then(function () {
          if (!extra.length) return null;
          return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-DMR-Sync': '1' }, body: JSON.stringify({ items: extra.map(function (a) { return { id: a.variant, quantity: qty(), properties: { _gpo_parent_product_group: group, _gpo_field_name: a.field } }; }) }) })
            .then(function (r) { if (!r.ok) throw new Error('addons'); return r.json(); });
        })
        .then(function () {
          if (!editLine) return null;
          return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-DMR-Sync': '1' }, body: JSON.stringify({ id: editLine.key, quantity: 0 }) });
        })
        .then(function () {
          if (editLine) { if (d.dmrInline) { document.dispatchEvent(new CustomEvent('dmr:cart-updated')); return; } window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart'; return; }
          btnLabel.textContent = S.added || oldLabel;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (d.redirect === 'true') window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart'; else { btn.disabled = false; setTimeout(function () { btnLabel.textContent = oldLabel; }, 2500); }
        })
        .catch(function () { btn.disabled = false; btnLabel.textContent = oldLabel; errEl.textContent = S.error || 'Erreur'; errEl.hidden = false; });
    }
    function textOf(el, raw) {
      var ov = (el.option_values || []).filter(function (o) { return o.value === raw; })[0];
      return ov ? valueText(el, ov) : raw;
    }

    function matchValue(el, txt) {
      var t = String(txt).trim();
      return (el.option_values || []).filter(function (o) {
        return Object.keys(o).some(function (k) { return /^value(_|$)/.test(k) && String(o[k]).trim() === t; });
      })[0];
    }
    function setBox(el, raw) {
      var box = formEl.querySelector('[data-dmr-el="' + el.id + '"]');
      if (!box) return;
      if (el.type === 'switch' || el.type === 'checkbox') { var c = box.querySelector('input'); if (c) c.checked = true; return; }
      if (el.type === 'text' || el.type === 'number' || el.type === 'textarea') { var f = box.querySelector('input[type=text], textarea'); if (f) f.value = raw; return; }
      var parts = el.allow_multiple ? String(raw).split(/\s*,\s*/) : [raw];
      if (el.type !== 'image-swatches' && el.type !== 'color-swatches') box.querySelectorAll('input[type=radio]').forEach(function (i) { i.checked = false; });
      else box.querySelectorAll('input').forEach(function (i) { i.checked = false; });
      parts.forEach(function (part) {
        var ov = matchValue(el, part); if (!ov) return;
        var inp = Array.prototype.filter.call(box.querySelectorAll('input[value], option[value]'), function (x) { return x.value === ov.value; })[0];
        if (inp) { if (inp.tagName === 'OPTION') inp.selected = true; else inp.checked = true; }
      });
    }
    function prefill() {
      return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        var line = cart.items.filter(function (it) { return it.properties && it.properties._gpo_product_group === editGroup; })[0];
        if (!line) return;
        editLine = { key: line.key, quantity: line.quantity };
        var props = line.properties || {};
        elements.forEach(function (el) {
          if (!TYPES_INPUT[el.type]) return;
          var key = el.label_on_cart || L(el, 'label', loc);
          if (el.type === 'file') {
            var kept = Object.keys(props).filter(function (k) { return (k === key || k.indexOf(key + ' ') === 0) && props[k]; }).map(function (k) { return [k, props[k]]; });
            if (kept.length) {
              keptFiles[el.id] = kept;
              var box = formEl.querySelector('[data-dmr-el="' + el.id + '"]');
              var names = box && box.querySelector('[data-dmr-names]');
              if (names) { names.textContent = (S.keptFiles || 'Fichiers déjà envoyés : ') + kept.length; box.classList.add('has-files'); }
            }
            return;
          }
          if (props[key] != null && props[key] !== '') setBox(el, props[key]);
        });
        btnLabel.textContent = S.update || 'Mettre à jour mon panier';
        rootEl.classList.add('is-editing');
        onChange();
        var names2 = formEl.querySelectorAll('.dmr-options__file.has-files [data-dmr-names]');
        names2.forEach(function (n) { var id = n.closest('[data-dmr-el]').dataset.dmrEl; if (keptFiles[id]) n.textContent = (S.keptFiles || 'Fichiers déjà envoyés : ') + keptFiles[id].length; });
      }).catch(function () {});
    }

    rootEl.dmrDebug = function () { readState(); return { state: state, vis: elements.filter(function (e) { return TYPES_INPUT[e.type]; }).map(function (e) { return [e.id, visible(e)]; }) }; };
    btn.addEventListener('click', submit);
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') onChange(); });
    document.addEventListener('variant:change', onChange);
    fetch(d.setUrl).then(function (r) { return r.json(); }).then(function (set) {
      elements = set.elements || [];
      elements.forEach(function (el) { byId[el.id] = el; });
      realPricesRef = realPrices; realComparesRef = realCompares;
      return loadRealPrices(set).then(render).then(function () { if (editGroup) return prefill(); });
    }).catch(function () { rootEl.querySelector('.dmr-options__loading').textContent = S.error || 'Erreur de chargement'; });
  }

  window.dmrOptionsBoot = function () { boot(); };
  function boot() { document.querySelectorAll('[data-dmr-options]').forEach(function (el) { if (!el.dataset.dmrReady) { el.dataset.dmrReady = '1'; init(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
